<template>
  <div>
    <a-form>
      <a-result status="success" title="报名成功" :is-success="true" sub-title="欢迎投标!" style="max-width: 560px; margin: 40px auto 0;">
      </a-result>
    </a-form>
  </div>
</template>

<script>
export default {
  name: 'Step3',
  data () {
    return {
      loading: false,
        timer:''
    }
  },
    created() {
      this.skip()
    },
    destroyed() {
        clearTimeout(this.timer);
    },
    methods: {
    finish () {
      this.$emit('finish')
    },
    toOrderList () {
      this.$router.push('/list/table-list')
    },
    skip() {
        let that = this
        this.timer = setTimeout(function () {
            that.$router.push({path:'/index'})
        },1000)
    }
  }
}
</script>
<style lang="less" scoped>
  .information {
    line-height: 22px;

    .ant-row:not(:last-child) {
      margin-bottom: 24px;
    }
  }
  .money {
    font-family: "Helvetica Neue",sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 14px;
  }
</style>
